export default __webpack_public_path__ + "static/media/ursinebrawl3.1996020d.png";